import { useEffect, useState } from "react";

// Hook media-query SSR-safe: inizializza sincrono per evitare flash di layout.
// Usato per scegliere UN SOLO albero (mobile vs desktop) ed evitare
// doppio rendering / testid duplicati / doppio fetch.
export const useMediaQuery = (query) => {
  const get = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false;

  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
};
